import { HttpError } from 'common-utils';
import { JsonValue } from 'type-fest';
import { z } from 'zod';

import { ErrorPayload, ResponseStatus } from '../resources/error-payload';

export type TUploadErrorCode = z.infer<typeof UploadErrorCode>;

export const UploadErrorCode = z.enum([
  'UNPAID_RE_UPLOAD',
  'DOCUMENT_TOO_LONG',
  'DOCUMENT_TOO_SHORT',
  'UPLOAD_TOO_LARGE',
  'LANGUAGE_NOT_SUPPORTED',
  'NOT_ENOUGH_ENGLISH_SENTENCES_FOUND',
  'INVALID_RE_UPLOAD',
  'PDF_RE_UPLOAD',
  'RE_UPLOAD_PERIOD_EXPIRED',
  'FAILED_TO_EXTRACT_DOCUMENT_CONTENT',
  'ENCRYPTED_FILE_ERROR',
  'INVALID_FILE_ERROR',
  'DOCUMENT_TOO_LARGE',
  'DOCUMENT_CONTENT_TOO_LARGE',
]);
export const uploadErrorHeadings: Record<TUploadErrorCode, string> = {
  PDF_RE_UPLOAD: 'Recheck feature is currently unavailable for PDF documents',
  UNPAID_RE_UPLOAD: 'Recheck is only available on paid documents',
  DOCUMENT_TOO_LONG: 'Your document is too long',
  DOCUMENT_TOO_SHORT: 'Your document is too short',
  UPLOAD_TOO_LARGE: 'Your document is too large',
  LANGUAGE_NOT_SUPPORTED: 'Your document language is unsupported',
  NOT_ENOUGH_ENGLISH_SENTENCES_FOUND: 'Your document language is unsupported',
  INVALID_RE_UPLOAD: 'Your document is not valid reupload',
  RE_UPLOAD_PERIOD_EXPIRED: 'Re-upload period has been expired',
  FAILED_TO_EXTRACT_DOCUMENT_CONTENT:
    'Please ensure that your document is saved in the .pdf, .doc, or .docx format (excluding the DOCX Strict format). If the problem persists, reach out to us at preflight-support@paperpal.com.',
  ENCRYPTED_FILE_ERROR: 'Your document is password protected or encrypted',
  INVALID_FILE_ERROR: 'Your file format is invalid or corrupted',
  DOCUMENT_TOO_LARGE: 'Your document is too large',
  DOCUMENT_CONTENT_TOO_LARGE: 'Your document content is too large',
} as const;

export type UploadErrorPayload = z.infer<typeof UploadErrorPayload>;

const UploadErrorPayload = ErrorPayload.extend({
  errorCode: UploadErrorCode,
});

export function isUploadErrorPayload(
  errorPayload: JsonValue,
): errorPayload is UploadErrorPayload {
  return UploadErrorPayload.safeParse(errorPayload).success;
}
export function isGeneric413(error: HttpError): boolean {
  const status = ResponseStatus.safeParse(error);
  const is413 = status.success && status.data === 413;
  const payload = UploadErrorPayload.safeParse(error.json);

  return !payload.success && is413;
}
